import { Menu, PenLine, Settings2 } from 'lucide-react';

const NAV_ITEMS = [
  ['cenarios', 'Cenários'],
  ['pressupostos', 'Pressupostos'],
  ['riscos', 'Riscos'],
  ['plano', '90 dias'],
];

export function AcqHeader({ active, onEdit, onOpenAdmin }) {
  return (
    <nav className="acq-nav" aria-label="Navegação do planeamento">
      <div className="acq-container acq-nav-inner">
        <a href="#top" className="acq-brand" data-testid="brand-link">
          Liofilândia
          <small>Planeamento executivo</small>
        </a>
        <div className="acq-nav-links">
          {NAV_ITEMS.map(([id, label]) => (
            <a
              key={id}
              href={`#${id}`}
              aria-current={active === id ? 'true' : undefined}
              data-testid={`nav-${id}`}
            >
              {label}
            </a>
          ))}
        </div>
        <div className="acq-nav-actions">
          {/* Unified plan editor — same as Apresentação */}
          <button className="btn btn-ghost btn-sm" onClick={onEdit || onOpenAdmin} data-testid="open-admin">
            <PenLine size={14} /> Editar plano
          </button>
          {/* Acquisition-specific pressupostos (scenarios, investment price) */}
          {onOpenAdmin && onEdit && (
            <button
              className="btn btn-ghost btn-sm acq-nav-admin-btn"
              onClick={onOpenAdmin}
              data-testid="open-admin-extra"
              title="Pressupostos do planeamento (cenários, investimento)"
            >
              <Settings2 size={14} />
            </button>
          )}
        </div>
      </div>
    </nav>
  );
}
